import React from 'react';
import InputWrapper from './InputWrapper';

const MAX_PHONE_LENGTH = 10;

const PhoneInput = ({ field, fieldId, value, onChange, label, isRequired, error, placeholder }) => {

  const fieldWithDefault = {
    ...field,
    labelOnSameRow: field.labelOnSameRow !== undefined ? field.labelOnSameRow : true
  };

  const handleChange = (e) => {
    const digitsOnly = (e.target.value || '').replace(/\D/g, '').slice(0, MAX_PHONE_LENGTH);
    onChange(fieldId, digitsOnly);
  };

  const displayValue = (value || '').replace(/\D/g, '').slice(0, MAX_PHONE_LENGTH);

  return (
    <InputWrapper field={fieldWithDefault} label={label} isRequired={isRequired} error={error}>
      <input
        type="tel"
        className="profile-input form-input"
        value={displayValue}
        onChange={handleChange}
        maxLength={MAX_PHONE_LENGTH}
        placeholder={placeholder || '1234567890'}
        disabled={field.readOnly || false}
      />
    </InputWrapper>
  );
};

export default PhoneInput;

